import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/AcquireFooter';
import { SEOHead } from '../components/SEO/SEOHead';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Contact form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <>
      <SEOHead title="Contact Us - AcquireFlow" description="Get in touch with the AcquireFlow team. We're here to help you automate your real estate investment workflow." canonical="https://acquireflow.com/contact" data-id="element-2545" />

      <div className="flex flex-col min-h-screen bg-gradient-to-b from-[#070707] via-[#0a0a0a] to-[#070707]" data-id="element-2546">
        <Navbar data-id="element-2547" />

        <main className="flex-grow" data-id="element-2548">
          {/* Hero Section */}
          <section className="relative w-full bg-gradient-to-b from-[#070707] via-[#0a0a0a] to-[#070707] py-20 px-6" data-id="element-2549">
            <div className="max-w-4xl mx-auto text-center" data-id="element-2550">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#3ab795]/10 border border-[#3ab795]/20 backdrop-blur-sm mb-6" data-id="element-2551">
                <div className="w-2 h-2 rounded-full bg-[#3ab795] animate-pulse" data-id="element-2552" />
                <p className="text-sm md:text-base font-medium text-[#3ab795] tracking-wide uppercase" data-id="element-2553">
                  Get In Touch
                </p>
              </div>

              <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight tracking-tight mb-6" data-id="element-2554">
                Let's Talk About Your{' '}
                <span className="text-[#3ab795] relative inline-block" data-id="element-2555">
                  Deal Flow
                  <span className="absolute -bottom-2 left-0 right-0 h-1 bg-[#3ab795]/30 rounded-full" data-id="element-2556"></span>
                </span>
              </h1>

              <p className="text-xl md:text-2xl text-[#b8bcc8] leading-relaxed font-light max-w-3xl mx-auto" data-id="element-2557">
                Have questions about AcquireFlow? Our team is here to help you
                automate your real estate investment workflow.
              </p>
            </div>
          </section>

          {/* Contact Section */}
          <section className="relative w-full bg-gradient-to-b from-[#070707] via-[#0a0a0a] to-[#070707] py-20 px-6" data-id="element-2558">
            <div className="max-w-6xl mx-auto" data-id="element-2559">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-2560">
                {/* Contact Form */}
                <div className="bg-gradient-to-br from-[#1a1a1a]/80 to-[#0f0f0f]/80 border border-white/10 rounded-2xl p-8 backdrop-blur-md" data-id="element-2561">
                  <h2 className="text-2xl font-bold text-white mb-6" data-id="element-2562">
                    Send Us a Message
                  </h2>

                  <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2563">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-2564">
                      <div data-id="element-2565">
                        <label htmlFor="name" className="block text-sm font-medium text-white mb-2" data-id="element-2566">
                          Full Name *
                        </label>
                        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-[#b8bcc8]/50 focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:border-transparent transition-all" placeholder="John Doe" required data-id="element-2567" />
                      </div>

                      <div data-id="element-2568">
                        <label htmlFor="email" className="block text-sm font-medium text-white mb-2" data-id="element-2569">
                          Email Address *
                        </label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-[#b8bcc8]/50 focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:border-transparent transition-all" placeholder="john@example.com" required data-id="element-2570" />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-2571">
                      <div data-id="element-2572">
                        <label htmlFor="phone" className="block text-sm font-medium text-white mb-2" data-id="element-2573">
                          Phone Number
                        </label>
                        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-[#b8bcc8]/50 focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:border-transparent transition-all" placeholder="(555) 123-4567" data-id="element-2574" />
                      </div>

                      <div data-id="element-2575">
                        <label htmlFor="company" className="block text-sm font-medium text-white mb-2" data-id="element-2576">
                          Company Name
                        </label>
                        <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-[#b8bcc8]/50 focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:border-transparent transition-all" placeholder="Your Company" data-id="element-2577" />
                      </div>
                    </div>

                    <div data-id="element-2578">
                      <label htmlFor="message" className="block text-sm font-medium text-white mb-2" data-id="element-2579">
                        Message *
                      </label>
                      <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={6} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-[#b8bcc8]/50 focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:border-transparent transition-all resize-none" placeholder="Tell us about your needs..." required data-id="element-2580" />
                    </div>

                    <button type="submit" className="w-full flex items-center justify-center gap-3 bg-[#3ab795] hover:bg-[#2da07d] text-white font-medium py-4 rounded-xl transition-all duration-300 hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:ring-offset-2 focus:ring-offset-[#0a0a0a]" data-id="element-2581">
                      Send Message
                      <Send className="w-5 h-5" data-id="element-2582" />
                    </button>
                  </form>
                </div>

                {/* Contact Information */}
                <div className="space-y-8" data-id="element-2583">
                  <div data-id="element-2584">
                    <h2 className="text-2xl font-bold text-white mb-6" data-id="element-2585">
                      Contact Information
                    </h2>
                    <p className="text-[#b8bcc8] mb-8" data-id="element-2586">
                      Reach out to us through any of these channels. We
                      typically respond within 24 hours.
                    </p>
                  </div>

                  <div className="space-y-6" data-id="element-2587">
                    <div className="flex items-start gap-4 p-4 bg-gradient-to-br from-[#1a1a1a]/60 to-[#0f0f0f]/60 border border-white/10 rounded-xl" data-id="element-2588">
                      <div className="w-12 h-12 bg-[#3ab795]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2589">
                        <Mail className="w-6 h-6 text-[#3ab795]" data-id="element-2590" />
                      </div>
                      <div data-id="element-2591">
                        <h3 className="text-white font-semibold mb-1" data-id="element-2592">Email</h3>
                        <a href="mailto:support@acquireflow.ai" className="text-[#b8bcc8] hover:text-[#3ab795] transition-colors" data-id="element-2593">
                          support@acquireflow.ai
                        </a>
                      </div>
                    </div>

                    <div className="flex items-start gap-4 p-4 bg-gradient-to-br from-[#1a1a1a]/60 to-[#0f0f0f]/60 border border-white/10 rounded-xl" data-id="element-2594">
                      <div className="w-12 h-12 bg-[#3ab795]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2595">
                        <Phone className="w-6 h-6 text-[#3ab795]" data-id="element-2596" />
                      </div>
                      <div data-id="element-2597">
                        <h3 className="text-white font-semibold mb-1" data-id="element-2598">Phone</h3>
                        <a href="tel:+18052090120" className="text-[#b8bcc8] hover:text-[#3ab795] transition-colors" data-id="element-2599">
                          +1 805-209-0120
                        </a>
                        <p className="text-sm text-[#b8bcc8]/70 mt-1" data-id="element-2600">
                          Mon-Fri, 9am-6pm EST
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4 p-4 bg-gradient-to-br from-[#1a1a1a]/60 to-[#0f0f0f]/60 border border-white/10 rounded-xl" data-id="element-2601">
                      <div className="w-12 h-12 bg-[#3ab795]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2602">
                        <MapPin className="w-6 h-6 text-[#3ab795]" data-id="element-2603" />
                      </div>
                      <div data-id="element-2604">
                        <h3 className="text-white font-semibold mb-1" data-id="element-2605">
                          Office
                        </h3>
                        <p className="text-[#b8bcc8]" data-id="element-2606">
                          ACQUIRE FLOW LLC
                          <br data-id="element-2607" />
                          254 Chapman Rd, Ste 208 #25827
                          <br data-id="element-2608" />
                          Newark, Delaware 19702 US
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* CTA Box */}
                  <div className="bg-gradient-to-br from-[#3ab795]/10 to-[#3ab795]/5 border border-[#3ab795]/20 rounded-xl p-6" data-id="element-2609">
                    <h3 className="text-white font-semibold mb-2" data-id="element-2610">
                      Ready to Get Started?
                    </h3>
                    <p className="text-[#b8bcc8] mb-4" data-id="element-2611">
                      Start your 10-day free trial today. No credit card
                      required.
                    </p>
                    <a href="#pricing" className="inline-flex items-center gap-2 text-[#3ab795] hover:text-[#2da07d] font-medium transition-colors" data-id="element-2612">
                      View Pricing Plans
                      <Send className="w-4 h-4" data-id="element-2613" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer data-id="element-2614" />
      </div>
    </>;
}